import React from 'react';
import exclamation from '@assets/images/exclamation.svg';
import styled from 'styled-components';

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  marginTop?: number;
  marginBottom?: number;
}

const Container = styled.div<ContainerProps>`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100%;

  gap: 0.5rem;

  margin-top: ${({ marginTop }) => `${marginTop === undefined ? '30' : marginTop}px`};
  margin-bottom: ${({ marginBottom }) => `${marginBottom === undefined ? '30' : marginBottom}px`};

  > p {
    font-weight: 600;
    color: #747474;
    font-size: 0.875rem;
    text-align: center;
    line-height: 150%;
    white-space: pre-line;
    word-break: keep-all;
    margin: 0;
  }
`;

interface NotFoundContainerProps {
  text: string;
  marginTop?: number;
  marginBottom?: number;
}

const NotFoundContainer = ({ text, marginTop, marginBottom }: NotFoundContainerProps) => {
  return (
    <Container marginTop={marginTop} marginBottom={marginBottom}>
      <img src={exclamation} alt="exclamation icon" />
      <p className="notFoundText">{text}</p>
    </Container>
  );
};
export default NotFoundContainer;
